/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2018-present Daewoong Moon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

// Source: https://github.com/wiziple/browser-lang

import 'client-only'

export function browserLang(options?: { languages?: string[]; fallback?: string }) {
    if (!options) {
        return getBrowserLang()
    }

    const { languages, fallback } = options
    if (!languages) {
        return fallback
    }

    // some browsers report language as en-US instead of en_US
    const browserLanguage = normalizeCode(getBrowserLang())
    if (!browserLanguage) {
        return fallback
    }

    const match = languages.filter((lang) => normalizeCode(lang) === browserLanguage)

    if (match.length > 0) {
        return match[0] || fallback
    }

    // en == en_US
    const matchCodeOnly = languages.filter(
        (lang) => startsWith(browserLanguage, lang) || startsWith(lang, browserLanguage)
    )
    return matchCodeOnly[0] || fallback
}

function getBrowserLang() {
    if (typeof window === 'undefined') {
        return null
    }

    const lang =
        window.navigator.languages?.[0] ||
        window.navigator.language ||
        // @ts-expect-error
        window.navigator.browserLanguage ||
        // @ts-expect-error
        window.navigator.userLanguage ||
        // @ts-expect-error
        window.navigator.systemLanguage ||
        null

    return lang
}

function normalizeCode(code: string) {
    return code.toLowerCase().replace(/-/u, '_')
}

function startsWith(input: string, target: string) {
    return input.slice(0, target.length) === target
}
